var ExchangeRateController = (function () {
    function ExchangeRateController(settings, env, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.table = {
            filter: false, filterParams: {}, filters: { CURRENCY: '' }, search: '', select_options: {}, visible: 0
        };
        this.records = [];
        this.recordsLoaded = false;
        this.importingExcel = false;
        this.exportFired = false;
        this.isSaving = false;
        this.docTable = [];
        this.historyInfo = {};
        this.historyTable = {
            instance: {}
        };
        this.backendModuleName = 'admin/exchange/exchange';
        this.scopePrefix = 'admin.exchangeRates';
        this.scopeGetData = this.scopePrefix + ".query";
        this.scopeGetLogs = this.scopePrefix + ".logs";
        this.scopeUpdateLogs = this.scopePrefix + ".logsUpdate";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeDeleteAll = this.scopePrefix + ".deleteall";
        this.scopeExport = this.scopePrefix + ".export";
        this.scopeExportTemplate = this.scopePrefix + ".exportTemplate";
        this.scopeImportFromExcel = this.scopePrefix + ".importFromExcel";
        this.scopeReplaceFromExcel = this.scopePrefix + ".replaceAllFromExcel";
        this.historyInfo = {
            currency: '',
            startDate: '',
            endDate: ''
        };
        this.table.headers = [{
                'Currency': 'CURRENCY',
                'From USD': 'FROMUSD',
                'To USD': 'TOUSD',
                'Start Date': 'STARTDATE',
                'End Date': 'ENDDATE',
                'Active': 'ACTIVE',
                'Created Date': 'CREATED',
                'Last Update': 'LAST_UPDATE',
                'Inactive From': 'INACTIVE_FROM',
                'Created By': 'CREATED_BY',
                'Updated By': 'UPDATED_BY'
            }];
        this.table.options = DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption("searchDelay", 350)
            .withOption("alphabetColumnIndex", 0)
            .withOption('order', [[3, 'desc']]); // Default sorting by start date descending order
        this.table.columnDefs = [
            DTColumnDefBuilder.newColumnDef(11).notSortable() // Disable sorting for "Actions" column
        ];
        this.historyTable.options = DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption('stateSave', true)
            .withOption('ordering', false)
            .withOption("searchDelay", 350)
            .withOption("alphabetColumnIndex", 2);
        this.historyTable.columnDefs = [];
        //GET ALL
        this.socket.forward(this.scopeGetData, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetData, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Loading records');
                return _this.notify.error('Error with loading records');
            }
            else {
                _this.records = _this.convertToViewModels(data.payload);
                _this.recordsLoaded = true;
            }
        });
        //GET HISTORY
        this.socket.forward(this.scopeGetLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetLogs, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Get history data');
                return _this.notify.error("Unable to get history data");
            }
            else {
                if (data.payload.logs) {
                    _this.docTable = data.payload.logs.reverse();
                }
            }
        });
        //UPDATED HISTORY
        this.socket.forward(this.scopeUpdateLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateLogs, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update history data');
                return _this.notify.error("Unable to update history data");
            }
            else {
                _this.getHistory();
            }
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            _this.isSaving = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update record');
                return _this.notify.error("Unable to update record");
            }
            else {
                _this.notify.success('Update successful!');
                _this.sendNewHistoryLog('Edited record');
                return _this.initFunction();
            }
        });
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create record');
                return _this.notify.error("Unable to create record");
            }
            else {
                _this.notify.success('Record was added!');
                _this.sendNewHistoryLog('Created record');
                return _this.initFunction();
            }
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                return _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.sendNewHistoryLog('Deleted record');
                return _this.initFunction();
            }
        });
        // DELETE ALL
        this.socket.forward(this.scopeDeleteAll, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteAll, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete all records');
                return _this.notify.error("Unable to delete all records");
            }
            else {
                _this.notify.success('All records was deleted successful!');
                _this.sendNewHistoryLog('Deleted all records');
                return _this.initFunction();
            }
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data.payload, 'dmt-exchange-rates');
                return _this.notify.success('Export was successful!');
            }
        });
        // DOWNLOAD EXCEL TEMPLATE
        this.socket.forward(this.scopeExportTemplate, this.$scope);
        this.$scope.$on("socket:" + this.scopeExportTemplate, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting template');
                return _this.notify.error("Can't to export latest template");
            }
            else {
                _this.downloadFile(data.payload, 'dmt-exchange-rates-template');
                return _this.notify.success('Template downloaded successfully!');
            }
        });
        // UPLOADADD
        this.socket.forward(this.scopeImportFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeImportFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Add from Excel');
                _this.notify.error("Can't to upload and add from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and add from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
        // UPLOADREPLACE
        this.socket.forward(this.scopeReplaceFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeReplaceFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Replace from Excel');
                _this.notify.error("Can't to upload and replace from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and replace from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
    }
    ExchangeRateController.prototype.convertToViewModels = function (payload) {
        if (!payload) {
            payload = [];
        }
        function formatNumber(number) {
            return parseFloat(number.toString().replace(/,/g, '.'));
        }
        return payload.map(function (item) {
            return Object.assign({}, item, {
                FROMUSD: formatNumber(item.FROMUSD),
                TOUSD: formatNumber(item.TOUSD)
            });
        });
    };
    /**
     * Function to handle all errors
     */
    ExchangeRateController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    ExchangeRateController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    /**
     * Function to download files
     */
    ExchangeRateController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    /**
     * Function to export
     */
    ExchangeRateController.prototype.export = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                function: 'exportToExcel',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to create new record
     */
    ExchangeRateController.prototype.createRecord = function (event) {
        var _this = this;
        var tit = 'Add record to existing list';
        var date = new Date();
        var nextDay = new Date(date.valueOf() + 1 * 1000 * 60 * 60 * 24);
        var inactiveFrom = new Date('2999-12-31');
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add records to existing list?',
            title: tit,
            record: {
                CURRENCY: '',
                FROMUSD: '',
                TOUSD: '',
                STARTDATE: date,
                ENDDATE: nextDay,
                ACTIVE: 'Y',
                INACTIVE_FROM: inactiveFrom
            }
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.Dialog.updateValidForm(event, items, 'exchange-rate-insert.html').then(function (answer) {
                    items.record = answer.record;
                    items.record.STARTDATE = _this.dateToString(items.record.STARTDATE);
                    items.record.ENDDATE = _this.dateToString(items.record.ENDDATE);
                    items.record.INACTIVE_FROM = _this.dateToString(items.record.INACTIVE_FROM);
                    items.record.CREATED_BY = _this.env.user.email;
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            data: items.record,
                            function: 'insertRecord',
                            scopeBack: _this.scopeCreateRecord,
                            script: _this.backendModuleName,
                            token: _this.env.user.token,
                            email: _this.env.user.email
                        }
                    });
                    _this.historyInfo.currency = items.record.CURRENCY;
                    _this.historyInfo.startDate = items.record.STARTDATE;
                    _this.historyInfo.endDate = items.record.ENDDATE;
                });
            }
        });
        return;
    };
    ExchangeRateController.prototype.getRecordById = function (id) {
        return this.records.find(function (cl) { return cl['ID'] === id; });
    };
    /**
     * Function to edit record
     */
    ExchangeRateController.prototype.editRecord = function (event, editableRecord) {
        var _this = this;
        console.info("Record: " + editableRecord);
        var updatedData = {
            content: {
                ID: editableRecord['ID'],
                CURRENCY: editableRecord['CURRENCY'],
                FROMUSD: editableRecord['FROMUSD'],
                TOUSD: editableRecord['TOUSD'],
                STARTDATE: new Date(editableRecord['STARTDATE']),
                ENDDATE: new Date(editableRecord['ENDDATE']),
                ACTIVE: editableRecord['ACTIVE'],
                INACTIVE_FROM: new Date(editableRecord['INACTIVE_FROM'])
            }
        };
        this.Dialog.updateValidForm(event, updatedData, 'exchange-rate-edit.html').then(function (dResult) {
            updatedData.content.STARTDATE = _this.dateToString(updatedData.content.STARTDATE);
            updatedData.content.ENDDATE = _this.dateToString(updatedData.content.ENDDATE);
            updatedData.content.INACTIVE_FROM = _this.dateToString(updatedData.content.INACTIVE_FROM);
            _this.isSaving = true;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: updatedData.content,
                    function: 'updateRecord',
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token,
                    email: _this.env.user.email
                }
            });
            _this.historyInfo.currency = updatedData.content.CURRENCY;
            _this.historyInfo.startDate = updatedData.content.STARTDATE;
            _this.historyInfo.endDate = updatedData.content.ENDDATE;
        });
        return;
    };
    ExchangeRateController.prototype.dateToString = function (date) {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    };
    /**
     * Function to delete record
     */
    ExchangeRateController.prototype.deleteRecord = function (event, deleteRecord) {
        var _this = this;
        //let deleteRecord: any = {};
        this.Dialog.confirmDelete(event, deleteRecord).then(function (dResult) {
            if (dResult) {
                //deleteRecord = this.getRecordById(idx);
                var deletedData = {
                    ID: deleteRecord.ID
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: deletedData,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
            _this.historyInfo.currency = deleteRecord.CURRENCY;
            _this.historyInfo.startDate = deleteRecord.STARTDATE;
            _this.historyInfo.endDate = deleteRecord.ENDDATE;
        });
        return;
    };
    /**
     * Function to delete all records
     */
    ExchangeRateController.prototype.deleteAllRecords = function (event) {
        var _this = this;
        this.Dialog.confirmDelete(event).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'deleteAllRecords',
                        scopeBack: _this.scopeDeleteAll,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
        });
        return;
    };
    /**
     * Function to upload new list
     */
    ExchangeRateController.prototype.uploadRecordList = function (event) {
        var _this = this;
        var tit = 'Upload new list';
        var items = {
            icon: 'QUESTION',
            message: 'Do you want to add items to existing records or replace the existing list?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'newclient-update-add.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.uploadFilesAdd(dResult.data[0]);
            }
            else {
                var tit1 = 'Replace existing list';
                var items1 = {
                    icon: 'QUESTION',
                    message: 'Are you sure you want to completely replace the existing list?',
                    title: tit1
                };
                _this.Dialog.updateValidForm(event, items1, 'newclient-update-replace.html').then(function (dResult1) {
                    if (dResult1.confirm) {
                        _this.uploadFilesReplace(dResult1.data[0]);
                    }
                });
            }
        });
        return;
    };
    /**
     * Functions to prepare the files for file upload ADD
     */
    ExchangeRateController.prototype.uploadFilesAdd = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'importFromExcel',
                    scopeBack: this.scopeImportFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Functions to prepare the files for file upload REPLACE
     */
    ExchangeRateController.prototype.uploadFilesReplace = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'replaceAllFromExcel',
                    scopeBack: this.scopeReplaceFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Function to download template
     */
    ExchangeRateController.prototype.downloadTemplate = function (event) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadExcelTemplate',
                scopeBack: this.scopeExportTemplate,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to get all records in DB2
     */
    ExchangeRateController.prototype.initFunction = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getData',
                scopeBack: this.scopeGetData,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to get all history from Cloudant
     */
    ExchangeRateController.prototype.getHistory = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getHistoryLogs',
                scopeBack: this.scopeGetLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to send updated history to Cloudant
     */
    ExchangeRateController.prototype.sendNewHistoryLog = function (operation) {
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var oneHist = {
            comment: (operation === 'Deleted record' || operation === 'Edited record' || operation === 'Created record') ?
                [(operation + " with currency: " + this.historyInfo.currency + ", start date: " + this.historyInfo.startDate + ", end date: " + this.historyInfo.endDate)] :
                [("" + operation)],
            timestamp: timeText,
            user: this.env.user.email
        };
        this.docTable.reverse();
        this.docTable.push(oneHist);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateHistoryLogs',
                scopeBack: this.scopeUpdateLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTable
            }
        });
    };
    ExchangeRateController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    ExchangeRateController.prototype.$onInit = function () {
        this.initFunction();
        this.getHistory();
    };
    ExchangeRateController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    ExchangeRateController.$inject = [
        'settings',
        'env',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return ExchangeRateController;
}());
var ExchangeRateComponent = (function () {
    function ExchangeRateComponent() {
        this.templateUrl = 'exchangerate-view.html';
        this.controllerAs = 'vm';
        this.controller = ExchangeRateController;
    }
    return ExchangeRateComponent;
}());
angular
    .module('application')
    .filter("stringToDateFormat", function ($filter) {
    return function (input, format) {
        return $filter("date")(new Date(input), format);
    };
})
    .component('viewExchangerateSection', new ExchangeRateComponent());

//# sourceMappingURL=exchangerate.view.component.js.map
